// extracted by mini-css-extract-plugin
module.exports = {"label":"Editor_label__RsA0V","editor_wrapper":"Editor_editor_wrapper__soXuP","editor":"Editor_editor___cUc9","options":"Editor_options__9H9EL"};